import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "container-fluid d-flex flex-column" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "me-3" }

import PersonContactDataEditor from "@/components/PersonContactDataEditor.vue";
import LanguageSelect from "@/components/LanguageSelect.vue";
import { useValidateProps } from "@/composables/fields";
import { dbEnums } from "@/types/enums/dbEnums";
import { CompanyDto } from "@api/company-dto";
import { PropType, computed } from "vue";
import { CompanyFieldCategoryMap } from "..";
import Field from "../../Field.vue";
import FormFields from "../../FormFields.vue";
import FormSection from "../../FormSection.vue";
import FormSectionHeader from "../../FormSectionHeader.vue";
import { PersonCompanyDataDto } from "@api/person-company-data-dto";
import { PersonContactDataDto } from "@api/person-contact-data-dto";
import { PersonDto } from "@api/person-dto";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyUpdateFormPersonsFields',
  props: {
	fieldsMap: {
		type: Object as PropType<CompanyFieldCategoryMap>,
		required: true,
	},
	modelValue: {
		type: Object as PropType<CompanyDto>,
		required: true,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const fields = dbEnums.CompanyFields;

const props = __props;

const emit = __emit;

const formDataComputed = computed({
	get() {
		return props.modelValue;
	},
	set(v) {
		emit("update:modelValue", v);
	},
});

const cPersonCount = computed(() => {
	return formDataComputed.value.personCompanyDatas?.filter((x) => x.id > 0).length ?? 0;
});

const addNewCompanyPerson = () => {
	formDataComputed.value.personCompanyDatas?.push({
		companyId: formDataComputed.value.id,
		contactDatas: [] as PersonContactDataDto[],
		title: "",
		phoneNumber: "",
		postalAddress: {},
		isCompanyInfoUpdateRequestRecipient: false,
		personId: 0,
		person: {
			id: 0,
			firstName: "",
			lastName: "",
			secondNames: "",
			isActive: true,
			isElectronicCommunicationAllowed: true,
			communicationLanguageId: null,
			communicationLanguage: null,
			birthday: null,
		} as unknown as PersonDto,
	} as PersonCompanyDataDto);
};

const removeNewCompanyPerson = (index: number) => {
	formDataComputed.value.personCompanyDatas?.splice(index, 1);
};

const validateProps = useValidateProps();

return (_ctx: any,_cache: any) => {
  const _component_HakoButton = _resolveComponent("HakoButton")!
  const _component_HakoCheckbox = _resolveComponent("HakoCheckbox")!
  const _component_HakoInput = _resolveComponent("HakoInput")!
  const _component_HakoDatePicker = _resolveComponent("HakoDatePicker")!
  const _component_HakoContentBlock = _resolveComponent("HakoContentBlock")!

  return (_openBlock(), _createBlock(FormSection, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FormSectionHeader, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("companyForm.sectionPersons.header")), 1)
            ]),
            _: 1
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formDataComputed.value.personCompanyDatas, (person, index) => {
          return (_openBlock(), _createBlock(_component_HakoContentBlock, {
            key: 'person' + index,
            label: 
					person.personId
						? person.person.fullName
						: _ctx.$t('companyForm.newPerson') + ' #' + (index - cPersonCount.value + 1)
				,
            theme: person.isActive ? 'contact' : 'secondary',
            class: "mb-3",
            collapsed: ""
          }, {
            header: _withCtx(() => [
              (!person.personId)
                ? (_openBlock(), _createBlock(_component_HakoButton, {
                    key: 0,
                    onClick: ($event: any) => (removeNewCompanyPerson(index)),
                    theme: "danger"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("generic.delete")), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : (_openBlock(), _createBlock(_component_HakoCheckbox, {
                    key: 1,
                    "model-value": !person.isActive,
                    "onUpdate:modelValue": ($event: any) => (person.isActive = !$event)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("generic.isActive")), 1)
                    ]),
                    _: 2
                  }, 1032, ["model-value", "onUpdate:modelValue"]))
            ]),
            default: _withCtx(() => [
              (__props.fieldsMap.CompanyUpdatePersonsInfo)
                ? (_openBlock(), _createBlock(FormFields, {
                    key: 0,
                    fields: __props.fieldsMap.CompanyUpdatePersonsInfo.fields
                  }, {
                    [_unref(fields).CompanyUpdatePersonFirstName]: _withCtx(({ field }) => [
                      _createVNode(Field, {
                        field: field,
                        propertyPath: `personCompanyDatas[${index}].person.firstName`,
                        isUpdateForm: ""
                      }, {
                        default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                          _createVNode(_component_HakoInput, {
                            modelValue: person.person.firstName,
                            "onUpdate:modelValue": ($event: any) => ((person.person.firstName) = $event),
                            id: elementId,
                            isInvalid: isInvalid,
                            onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                            style: {"max-width":"500px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "isInvalid", "onBlur"])
                        ]),
                        _: 2
                      }, 1032, ["field", "propertyPath"])
                    ]),
                    [_unref(fields).CompanyUpdatePersonSecondNames]: _withCtx(({ field }) => [
                      _createVNode(Field, {
                        field: field,
                        propertyPath: `personCompanyDatas[${index}].person.secondNames`,
                        isUpdateForm: ""
                      }, {
                        default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                          _createVNode(_component_HakoInput, {
                            modelValue: person.person.secondNames,
                            "onUpdate:modelValue": ($event: any) => ((person.person.secondNames) = $event),
                            id: elementId,
                            isInvalid: isInvalid,
                            onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                            style: {"max-width":"500px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "isInvalid", "onBlur"])
                        ]),
                        _: 2
                      }, 1032, ["field", "propertyPath"])
                    ]),
                    [_unref(fields).CompanyUpdatePersonLastName]: _withCtx(({ field }) => [
                      _createVNode(Field, {
                        field: field,
                        propertyPath: `personCompanyDatas[${index}].person.lastName`,
                        isUpdateForm: ""
                      }, {
                        default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                          _createVNode(_component_HakoInput, {
                            modelValue: person.person.lastName,
                            "onUpdate:modelValue": ($event: any) => ((person.person.lastName) = $event),
                            id: elementId,
                            isInvalid: isInvalid,
                            onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                            style: {"max-width":"500px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "isInvalid", "onBlur"])
                        ]),
                        _: 2
                      }, 1032, ["field", "propertyPath"])
                    ]),
                    [_unref(fields).CompanyUpdatePersonIsElectronicCommunicationAllowed]: _withCtx(({ field }) => [
                      _createVNode(Field, {
                        field: field,
                        propertyPath: `personCompanyDatas[${index}].person.isElectronicCommunicationAllowed`,
                        isUpdateForm: ""
                      }, {
                        default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                          _createVNode(_component_HakoCheckbox, {
                            modelValue: person.person.isElectronicCommunicationAllowed,
                            "onUpdate:modelValue": ($event: any) => ((person.person.isElectronicCommunicationAllowed) = $event),
                            for: elementId,
                            isInvalid: isInvalid,
                            onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("generic.yes")), 1)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "for", "isInvalid", "onBlur"])
                        ]),
                        _: 2
                      }, 1032, ["field", "propertyPath"])
                    ]),
                    [_unref(fields).CompanyUpdatePersonTitle]: _withCtx(({ field }) => [
                      _createVNode(Field, {
                        field: field,
                        propertyPath: `personCompanyDatas[${index}].title`,
                        isUpdateForm: ""
                      }, {
                        default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                          _createVNode(_component_HakoInput, {
                            modelValue: person.title,
                            "onUpdate:modelValue": ($event: any) => ((person.title) = $event),
                            id: elementId,
                            isInvalid: isInvalid,
                            onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                            style: {"max-width":"500px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "isInvalid", "onBlur"])
                        ]),
                        _: 2
                      }, 1032, ["field", "propertyPath"])
                    ]),
                    [_unref(fields).CompanyUpdatePersonDateOfBirth]: _withCtx(({ field }) => [
                      _createVNode(Field, {
                        field: field,
                        propertyPath: `personCompanyDatas[${index}].person.birthday`,
                        isUpdateForm: ""
                      }, {
                        default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                          _createVNode(_component_HakoDatePicker, {
                            modelValue: person.person.birthday,
                            "onUpdate:modelValue": ($event: any) => ((person.person.birthday) = $event),
                            allowEmpty: true,
                            id: elementId,
                            isInvalid: isInvalid,
                            onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                            placeholder: _ctx.$t('generic.datePlaceholder'),
                            style: {"max-width":"250px"},
                            forceUtcMidnight: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "isInvalid", "onBlur", "placeholder"])
                        ]),
                        _: 2
                      }, 1032, ["field", "propertyPath"])
                    ]),
                    [_unref(fields).CompanyUpdatePersonEmails]: _withCtx(({ field }) => [
                      _createVNode(Field, {
                        field: field,
                        isUpdateForm: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(PersonContactDataEditor, {
                            modelValue: person.contactDatas,
                            "onUpdate:modelValue": ($event: any) => ((person.contactDatas) = $event),
                            type: _unref(dbEnums).ContactDataType.Email,
                            field: field,
                            onValidate: _unref(validateProps),
                            propertyPathBase: `personCompanyDatas[${index}]`,
                            style: {"max-width":"500px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "type", "field", "onValidate", "propertyPathBase"])
                        ]),
                        _: 2
                      }, 1032, ["field"])
                    ]),
                    [_unref(fields).CompanyUpdatePersonPhoneNumbers]: _withCtx(({ field }) => [
                      _createVNode(Field, {
                        field: field,
                        isUpdateForm: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(PersonContactDataEditor, {
                            modelValue: person.contactDatas,
                            "onUpdate:modelValue": ($event: any) => ((person.contactDatas) = $event),
                            type: _unref(dbEnums).ContactDataType.Phone,
                            field: field,
                            onValidate: _unref(validateProps),
                            propertyPathBase: `personCompanyDatas[${index}]`,
                            style: {"max-width":"250px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "type", "field", "onValidate", "propertyPathBase"])
                        ]),
                        _: 2
                      }, 1032, ["field"])
                    ]),
                    [_unref(fields).CompanyUpdatePersonLanguage]: _withCtx(({ field }) => [
                      _createVNode(Field, {
                        field: field,
                        propertyPath: `personCompanyDatas[${index}].person.communicationLanguageId`,
                        isUpdateForm: ""
                      }, {
                        default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                          _createVNode(LanguageSelect, {
                            valueSingle: person.person.communicationLanguage,
                            "onUpdate:valueSingle": ($event: any) => ((person.person.communicationLanguage) = $event),
                            valueSingleId: person.person.communicationLanguageId,
                            "onUpdate:valueSingleId": ($event: any) => ((person.person.communicationLanguageId) = $event),
                            communicationRole: _unref(dbEnums).PersonUserRoleIds.Elinkeino,
                            id: elementId,
                            isInvalid: isInvalid,
                            onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                            style: {"max-width":"250px"}
                          }, null, 8, ["valueSingle", "onUpdate:valueSingle", "valueSingleId", "onUpdate:valueSingleId", "communicationRole", "id", "isInvalid", "onBlur"])
                        ]),
                        _: 2
                      }, 1032, ["field", "propertyPath"])
                    ]),
                    [_unref(fields).CompanyUpdatePersonIsInfoUpdateRequestRecipient]: _withCtx(({ field }) => [
                      _createVNode(Field, {
                        field: field,
                        propertyPath: `personCompanyDatas[${index}].isCompanyInfoUpdateRequestRecipient`,
                        isUpdateForm: ""
                      }, {
                        default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                          _createVNode(_component_HakoCheckbox, {
                            modelValue: person.isCompanyInfoUpdateRequestRecipient,
                            "onUpdate:modelValue": ($event: any) => ((person.isCompanyInfoUpdateRequestRecipient) = $event),
                            for: elementId,
                            isInvalid: isInvalid,
                            onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("generic.yes")), 1)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "for", "isInvalid", "onBlur"])
                        ]),
                        _: 2
                      }, 1032, ["field", "propertyPath"])
                    ]),
                    _: 2
                  }, 1032, ["fields"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["label", "theme"]))
        }), 128)),
        _createVNode(_component_HakoButton, {
          theme: "success",
          onClick: addNewCompanyPerson,
          class: "mt-3 ms-auto"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("companyForm.addNewCompanyPerson")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})